import { StorefrontHero } from "@softmax/product-ux/catalog";
import { storefrontSlots, type StorefrontProps } from "./storefront-slots";
export function PreviewStorefront(props: StorefrontProps) {
  return <StorefrontHero {...storefrontSlots(props)} />;
}
